import { MasterConfigs } from "../../interfaces/entity";
import { Typography } from "antd";
const { Title } = Typography;

const AddressConfig: MasterConfigs = {
    api: () => "/users",
    modalTitle: () => "Edit User",
    maskClosable: false,
    hideAddMoreButton: true,
    getFormColumns: () => [
        {
            type: "custom",
            formItem: () => <Title level={5}>Permanent Address</Title>,
            span: 24
        },
        {
            label: "Permanent Address",
            name: "permanentAddress",
            type: "form",
            span: 24,
            form: [
                {
                    label: "Address",
                    name: "address",
                    type: "text",
                },
                {
                    label: "City",
                    name: "city",
                    type: "text",
                },
                {
                    label: "State",
                    name: "state",
                    type: "text",
                },
                {
                    label: "Pincode",
                    name: "pincode",
                    type: "text",
                },
                {
                    label: "Country",
                    name: "country",
                    type: "text",
                },
            ]
        },
        {
            type: "custom",
            formItem: () => <Title level={5}>Current Address</Title>,
            span: 24
        },
        {
            label: "Current Address",
            name: "presentAddress",
            type: "form",
            span: 24,
            form: [
                {
                    label: "Address",
                    name: "address",
                    type: "text",
                },
                {
                    label: "City",
                    name: "city",
                    type: "text",
                },
                {
                    label: "State",
                    name: "state",
                    type: "text",
                },
                {
                    label: "Pincode",
                    name: "pincode",
                    type: "text",
                },
                {
                    label: "Country",
                    name: "country",
                    type: "text",
                },
            ]
        }
    ]
}


export default AddressConfig;